import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const PromisifiedAuthProvider = registerClientReference(
    function() { throw new Error("Attempted to call PromisifiedAuthProvider() from the server but PromisifiedAuthProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/@clerk/nextjs/dist/esm/client-boundary/PromisifiedAuthProvider.js",
    "PromisifiedAuthProvider",
);
export const usePromisifiedAuth = registerClientReference(
    function() { throw new Error("Attempted to call usePromisifiedAuth() from the server but usePromisifiedAuth is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/node_modules/@clerk/nextjs/dist/esm/client-boundary/PromisifiedAuthProvider.js",
    "usePromisifiedAuth",
);
